import {MetricsType} from './metrics-type.enum';
import {CustomMetricsName} from './custom-metrics-name.enum';
import { isNullOrUndefined } from 'util';

export class MetricsDataModel {
  name: string | CustomMetricsName;
  value?: any;
  timestamp?: any;
  openTimestamp?: any;
  closeTimestamp?: any;
  type?: MetricsType;

  constructor(name: string, type: MetricsType) {
      this.name = name;
      this.type = type;
  }

  open() {
    this.openTimestamp = new Date();
  }

  close() {
    this.closeTimestamp = new Date();
  }

  change(value?: any) {
    if (!isNullOrUndefined(value)) {
      this.value = value;
    }
    this.timestamp = new Date();
  }
}
